import { Autocomplete, Button, FormControl, InputLabel, MenuItem, Select, TextField, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, } from "@mui/material";
import { motion, AnimatePresence } from "motion/react";
import { useEffect, useState } from "react";
import LoadingSpinner from '../Spinner';
import { Flip, ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "./toastify/config";
import { styleBtn, sxTableHead, textFieldStyle } from "./Styles";
import apiCumbres from "../axios/axios";
import { useSelector } from 'react-redux';
import Swal from "sweetalert2";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // Para idioma español
import Tooltip from "./Tooltip";
import { IconButton } from "@mui/material";
import ArticleIcon from '@mui/icons-material/Article';
import PeopleIcon from '@mui/icons-material/People';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PostAddIcon from '@mui/icons-material/PostAdd';

const addClienteStyle = {
    boxShadow: "none", // sombra azul translúcida
    backgroundColor: '#0a2540',   // color que quieras
    borderRadius: '50%',
    padding: '8px',
    transition: "all 0.2s ease",  // transición suave
    color: '#f5f7fa',
    "&:hover": {
        backgroundColor: "#1259a7", // color más oscuro al pasar el mouse
        boxShadow: "0px 6px 20px rgba(18, 89, 167, 0.5)",
        transform: "translateY(-3px)", // se levanta hacia arriba
    },
}

const ContratoGrupal = () => {
    const tkn = useSelector((state) => state.tknAuth)
    const [isLoading, setIsLoading] = useState(false)

    const [tipoPrestamo, setTipoPrestamo] = useState(0)
    const [tipoPrestamoValue, setTipoPrestamoValue] = useState(0)
    const [catTipoPrestamo, setCatTipoPrestamo] = useState([])

    const [tipoPago, setTipoPago] = useState(0)

    const [catTipoPago, setCatTipoPago] = useState([])

    const [clienteContrato, setClienteContrato] = useState(null)
    const [catClientes, setCatClientes] = useState([])

    const [fechaComienzaContrato, setFechaComienzaContrato] = useState(null)
    const [fechaPrimerPago, setFechaPrimerPago] = useState(null)

    const [cantidadPrestar, setCantidadPrestar] = useState(0)
    const [cantidadPrestarFormateada, setCantidadPrestarFormateada] = useState(0)

    const [porcentajeInteres, setPorcentajeInteres] = useState('')
    const [mesesContrato, setMesesContrato] = useState('')
    const [interesPermitidoMin, setInteresPermitidoMin] = useState('')
    const [interesPermitidoMax, setInteresPermitidoMax] = useState('')
    const [cantidadPrestarMin, setCantidadPrestarMin] = useState('')
    const [cantidadPrestarMax, setCantidadPrestarMax] = useState('')
    const [garantiaPrestaria, setGarantiaPrestaria] = useState(0)
    const [garantiaPrestariaText, setGarantiaPrestariaText] = useState('')

    const [informacionGeneralAgregado, setInformacionGeneralAgregado] = useState(false)

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const [clientesAgregados, setClientesAgregados] = useState([])
    const [infoGeneralGuardado, setInfoGeneralGuardado] = useState(false)
    const [infoGeneralContrato, setInfoGeneralContrato] = useState({})

    const consultarCatalogos = () => {


        const catalogos = async () => {

            try {
                setIsLoading(true)

                //sacar rol del token
                const rolId = tkn.rolId

                const cats = await apiCumbres.get(`/registrar-contrato/catalogos/${rolId}`, {
                    headers: {
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setCatTipoPrestamo(cats.data.tipoPrestamos)
                setCatTipoPago(cats.data.tipoPagos)
                setCatClientes(cats.data.catClientes)

                setInteresPermitidoMin(cats.data.interesPermitido.interesPermitidoMin)
                setInteresPermitidoMax(cats.data.interesPermitido.interesPermitidoMax)

                setIsLoading(false)


            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    console.log(error.response)
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al obtener catalogos, favor de volver a intentarlo!'
                    }
                } else {
                    console.log(error)
                    msg_error = 'No hay respuesta por parte del servidor!'
                }
                //mensaje de toastify
                setIsLoading(false)
                toast.error(msg_error, toast_config)
            }

        }


        catalogos()

    }


    useEffect(() => {
        consultarCatalogos()
    }, [])

    const handleTipoPrestamo = (tp) => {
        setTipoPrestamo(tp.tipoPrestamoId)
        setTipoPrestamoValue(tp)
        setCantidadPrestarMin(tp.cantidadMin)
        setCantidadPrestarMax(tp.cantidadMax)
        setGarantiaPrestaria(tp.garantiaPrestaria)
        setGarantiaPrestariaText('')

    }

    const shouldDisableDate = (date) => {
        const day = date.date();
        // Solo permite días 1 y 16
        if (day !== 1 && day !== 16) return true;

        // Deshabilita fechas anteriores a hoy
        return date.isBefore(dayjs(), 'day');
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const agregarCliente = () => {

        Swal.fire({
            title: "Esta seguro?",
            text: `Se registrara contrato con la información seleccionada!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, registrar!"
        }).then((result) => {

            if (!result.isConfirmed) return

            const jContrato = [
                { label: 'Cantidad a Prestar', cantidadPrestar },
                { label: 'Cliente', cliente: clienteContrato },
                { label: 'Interes', interes: porcentajeInteres },
            ]

            if (garantiaPrestaria === '1') {
                jContrato.push({ label: 'Garantia Prestaria', garantiaPrestaria: garantiaPrestariaText })
            }

            // Validar que todos los campos tengan valor
            const emptyField = jContrato.find(f => {
                const value = Object.values(f)[1]; // segundo valor del objeto

                // Si es un array, debe tener al menos 1 elemento
                if (Array.isArray(value)) return value.length === 0;

                // Si es un número, debe ser mayor que 0
                if (typeof value === 'number') return value <= 0;

                // Si es string, debe tener contenido
                return !value?.toString().trim();
            });

            if (emptyField) {
                toast.error(`El campo "${emptyField.label}" es obligatorio.`, toast_config);
                return;
            }

            if (cantidadPrestar < cantidadPrestarMin) return toast.error(`La cantidad mínima del préstamo que escogiste es $ ${formatNumber(cantidadPrestarMin)}`)
            if (cantidadPrestar > cantidadPrestarMax) return toast.error(`La cantidad máximo del préstamo que escogiste es $ ${formatNumber(cantidadPrestarMax)}`)

            if (porcentajeInteres < interesPermitidoMin || porcentajeInteres > interesPermitidoMax) return toast.error(`El rango de interés que tienes permitido para este préstamo es mínimo de ${interesPermitidoMin}% y el máximo es ${interesPermitidoMax}%`)

            const nuevoCliente = {
                clienteId: clienteContrato,
                nombre: selectedOptionCliente.label,
                interes: porcentajeInteres,
                cantidadPrestar,
                cantidadPrestarFormateada
            }
            console.log(garantiaPrestaria)
            if (garantiaPrestaria === '1') {
                nuevoCliente.garantiaPrestaria = garantiaPrestariaText
            }

            setClientesAgregados((prev) => {
                const existe = prev.some(
                    (c) => c.clienteId === clienteContrato
                );

                if (existe) {
                    // aquí mandas el mensaje
                    toast.info('⚠️ Este cliente ya fue agregado', toast_config)
                    // o toast.error('Cliente duplicado')
                    return prev; // NO agrega nada
                }

                return [...prev, nuevoCliente];
            });

            setClienteContrato(null)
            setCantidadPrestar(0)
            setCantidadPrestarFormateada(0)
            setPorcentajeInteres('')
            if (garantiaPrestaria === '1') {
                setGarantiaPrestariaText('')
            }
        })



    }

    const agregarInfoGeneralContrato = () => {

        Swal.fire({
            title: "Está seguro?",
            text: `Se registrará la información general del contrato grupal!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, registrar!"
        }).then((result) => {
            if (!result.isConfirmed) return

            const jContrato = [
                { label: 'Tipo Prestamo', tipoPrestamoId: tipoPrestamo },
                { label: 'Tipo Pago', tipoPagoId: tipoPago },
                { label: 'Comienza Contrato', fechaComienzaContrato },
                { label: 'Primer Pago', fechaPrimerPagoContrato: fechaPrimerPago },
                { label: 'Meses', meses: mesesContrato },
            ]

            // Validar que todos los campos tengan valor
            const emptyField = jContrato.find(f => {
                const value = Object.values(f)[1]; // segundo valor del objeto

                // Si es un array, debe tener al menos 1 elemento
                if (Array.isArray(value)) return value.length === 0;

                // Si es un número, debe ser mayor que 0
                if (typeof value === 'number') return value <= 0;

                // Si es string, debe tener contenido
                return !value?.toString().trim();
            });

            if (emptyField) {
                toast.error(`El campo "${emptyField.label}" es obligatorio.`, toast_config);
                return;
            }


            setIsLoading(true)

            const jInfoGeneral = {
                tipoPrestamoId: tipoPrestamo,
                tipoPagoId: tipoPago,
                fechaComienzaContrato,
                fechaPrimerPagoContrato: fechaPrimerPago.format('YYYY-MM-DD'),
                meses: mesesContrato
            }

            setInfoGeneralContrato(jInfoGeneral)

            setIsLoading(false)
            setInfoGeneralGuardado(true)
            setInformacionGeneralAgregado(true)
            setClientesAgregados([])
            setClienteContrato(null)
            setCantidadPrestar(0)
            setCantidadPrestarFormateada(0)
            setPorcentajeInteres('')
            if (garantiaPrestaria === '1') {
                setGarantiaPrestariaText('')
            }


        })


    }

    const formatNumber = (value) => {
        const [intPart, decimalPart] = value.split('.');

        const formattedInt = parseInt(intPart, 10).toLocaleString('en-US');
        return decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : formattedInt;
    };

    const handleCantidadPrestar = (e) => {
        const input = e.target.value;

        const cleaned = input.replace(/,/g, '').replace(/[^\d.]/g, '');

        const parts = cleaned.split('.');
        if (parts.length > 2) return;

        // Guardar como número
        const numero = parseFloat(cleaned);

        const formateado = formatNumber(cleaned);

        setCantidadPrestar(isNaN(numero) ? 0 : numero)
        setCantidadPrestarFormateada(isNaN(numero) ? 0 : '$ ' + formateado)
    }

    const options = catClientes.map(cliente => ({
        id: cliente.clienteId,
        label: `${cliente.nombre} ${cliente.paterno} ${cliente.materno}`
    }));

    const selectedOptionCliente = options.find(op => op.id === clienteContrato) || null;

    const eliminarClienteGrupo = (e, id) => {
        setClientesAgregados((prev) => prev.filter(cliente => cliente.clienteId !== id));
    }

    const agregarContrato = () => {

        Swal.fire({
            title: "Esta seguro?",
            text: "Se guardara contrato grupal!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, guardar!"
        }).then((result) => {
            if (!result.isConfirmed) return

            if (clientesAgregados.length < 2) return toast.error('El contrato grupal debe de tener 2 o mas clientes!', toast_config)

            const jContrato = {
                tipoPrestamoId: infoGeneralContrato.tipoPrestamoId,
                tipoPagoId: infoGeneralContrato.tipoPagoId,
                clientes: clientesAgregados,
                fechaComienzaContrato: infoGeneralContrato.fechaComienzaContrato,
                fechaPrimerPagoContrato: infoGeneralContrato.fechaPrimerPagoContrato,
                meses: infoGeneralContrato.meses,

            }

            const agregarContratoGrupal = async () => {

                try {
                    setIsLoading(true)
                    jContrato.usuarioIdRegistro = tkn.usuarioId

                    const contratoGrupal = await apiCumbres.post('/registrar-contrato/crear-grupal', jContrato, {
                        headers: {
                            //token
                        }
                    })



                    setIsLoading(false)

                    Swal.fire({
                        icon: 'success',
                        title: 'Enhorabuena!',
                        text: contratoGrupal.data.mensaje
                    }).then((result) => {
                        window.location.href = '/registrar-contrato'
                    })

                } catch (error) {
                    let msg_error = ''
                    if (error.response) {
                        console.log(error.response)
                        if (error.response.data.error) {
                            msg_error = error.response.data.error
                        } else {
                            msg_error = 'Ocurrió un error al agregar contrato grupal, favor de volver a intentarlo!'
                        }
                    } else {
                        console.log(error)
                        msg_error = 'No hay respuesta por parte del servidor!'
                    }
                    //mensaje de toastify
                    setIsLoading(false)
                    toast.error(msg_error, toast_config)
                }

            }

            agregarContratoGrupal()

        });

    }



    return (
        <div className="container">
            {isLoading ?
                <LoadingSpinner />
                : null}
            <div className="row">
                <div className="col-md-12">
                    <Tooltip text={informacionGeneralAgregado ? 'INFORMACION GENERAL' : 'INFORMACION CLIENTE'} position="top">
                        <IconButton
                            disabled={!infoGeneralGuardado}
                            className="pointer mb-3"
                            onClick={() => setInformacionGeneralAgregado(!informacionGeneralAgregado)}
                            sx={{
                                ...addClienteStyle,
                                width: 48,
                                height: 48,
                            }}
                        >
                            {!informacionGeneralAgregado ? (
                                <PeopleIcon />
                            ) : (
                                <ArticleIcon />
                            )}
                        </IconButton>
                    </Tooltip>

                    <motion.div
                        layout
                        className="card shadow-lg  p-5 border-0"
                        style={{ borderRadius: '20px' }}
                        transition={{ duration: 0.45, ease: "easeInOut" }}
                    >

                        <div className="row">
                            <motion.div
                                className="col-md-10 mb-3"
                                initial={{ opacity: 0, y: -90 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.3 }}>

                                <h1 className="color-primary">Registrar Contrato Grupal</h1>
                            </motion.div>
                            {infoGeneralGuardado && clientesAgregados.length > 0 ?
                                <motion.div
                                    className="col-md-2 mb-3 text-end"
                                    initial={{ opacity: 0, x: -50 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    exit={{ opacity: 0, y: -40 }}
                                    transition={{ duration: 0.5, ease: "easeOut", delay: 0.4 }}
                                >
                                    <Tooltip text={'AGREGAR CONTRATO GRUPAL'} position="left">
                                        <IconButton
                                            disabled={!infoGeneralGuardado}
                                            className="pointer mb-3 "
                                            onClick={agregarContrato}
                                            sx={{
                                                ...addClienteStyle,
                                                width: 48,
                                                height: 48,
                                            }}
                                        >
                                            <PostAddIcon />
                                        </IconButton>
                                    </Tooltip>
                                </motion.div>
                                : null}
                            <hr className="mb-5" />


                            <AnimatePresence mode="popLayout">

                                {!informacionGeneralAgregado ? (
                                    <motion.div
                                        key="general"
                                        layout
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <motion.h4 className="color-primary mb-3"
                                            initial={{ opacity: 0, y: -90 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.5, ease: "easeOut", delay: 0.3 }}>
                                            Información General Contrato
                                        </motion.h4>

                                        <div className="row">

                                            <motion.div
                                                className="col-md-6 mb-3"
                                                initial={{ opacity: 0, x: -50 }}
                                                animate={{ opacity: 1, x: 0 }}
                                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.4 }}
                                            >
                                                <FormControl fullWidth sx={textFieldStyle}>
                                                    <InputLabel id="demo-simple-select-label">Tipo Préstamo</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        value={tipoPrestamoValue}
                                                        label="Tipo Prestamo"
                                                        onChange={(e) => handleTipoPrestamo(e.target.value)}

                                                    >
                                                        <MenuItem key={0} value={0} disabled>-SELECCIONAR TIPO DE PRÉSTAMO</MenuItem>
                                                        {catTipoPrestamo && catTipoPrestamo.map((tp) => (
                                                            <MenuItem key={tp.tipoPrestamoId} value={tp}>{tp.tipoPrestamo}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </motion.div>

                                            <motion.div
                                                className="col-md-6 mb-3"
                                                initial={{ opacity: 0, x: 50 }}
                                                animate={{ opacity: 1, x: 0 }}
                                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.5 }}
                                            >
                                                <FormControl fullWidth sx={textFieldStyle} disabled={!tipoPrestamo}>
                                                    <InputLabel id="demo-simple-select-label">Tipo Pago</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"

                                                        value={tipoPago}
                                                        label="Tipo Pago"
                                                        onChange={(e) => setTipoPago(e.target.value)}

                                                    >
                                                        <MenuItem key={0} value={0} disabled>-SELECCIONAR TIPO DE PAGO</MenuItem>
                                                        {catTipoPago && catTipoPago.map((tp) => (
                                                            <MenuItem key={tp.tipoPagoId} value={tp.tipoPagoId}>{tp.tipoPago}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </motion.div>

                                            <motion.div
                                                className="col-md-6 mb-3"
                                                initial={{ opacity: 0, x: -50 }}
                                                animate={{ opacity: 1, x: 0 }}
                                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.6 }}
                                            >
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        label="Seleccionar Comienzo Contrato"
                                                        value={fechaComienzaContrato}
                                                        onChange={(newValue) => setFechaComienzaContrato(newValue)}
                                                        slotProps={{
                                                            textField: {
                                                                fullWidth: true,
                                                                variant: "outlined",
                                                                sx: { textFieldStyle },
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>

                                            </motion.div>

                                            <motion.div
                                                className="col-md-6 mb-3"
                                                initial={{ opacity: 0, x: 50 }}
                                                animate={{ opacity: 1, x: 0 }}
                                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.7 }}
                                            >
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        disabled={!tipoPago || !tipoPrestamo}
                                                        label="Seleccionar Primer Pago Contrato"
                                                        value={fechaPrimerPago}
                                                        onChange={(newValue) => setFechaPrimerPago(newValue)}
                                                        shouldDisableDate={shouldDisableDate}
                                                        minDate={dayjs()} // Evita fechas pasadas
                                                        slotProps={{
                                                            textField: {
                                                                fullWidth: true,
                                                                variant: "outlined",
                                                                sx: { textFieldStyle },
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>

                                            </motion.div>

                                            <motion.div
                                                className="col-md-6 mb-3"
                                                initial={{ opacity: 0, x: -50 }}
                                                animate={{ opacity: 1, x: 0 }}
                                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.8 }}
                                            >
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth
                                                    label='Meses Duración'
                                                    sx={textFieldStyle}
                                                    value={mesesContrato}
                                                    onChange={(e) => {
                                                        const value = e.target.value;

                                                        // Permitir solo números enteros del 1 al 18
                                                        if (/^\d*$/.test(value)) { // Solo dígitos
                                                            const number = parseInt(value, 10);
                                                            if ((number >= 1 && number <= 24) || value === "") {
                                                                setMesesContrato(value);
                                                            }
                                                        }
                                                    }}
                                                />

                                            </motion.div>

                                            <motion.div
                                                className="col-md-12 mt-3"
                                                initial={{ opacity: 0, y: 50 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.9 }}
                                                whileHover={{
                                                    y: -4,
                                                    scale: 1.03,
                                                    filter: "brightness(1.1)",
                                                    transition: { duration: 0.25, ease: "easeOut" },
                                                }}
                                            >
                                                <Button variant="contained" fullWidth sx={styleBtn} onClick={agregarInfoGeneralContrato} >
                                                    Asignar
                                                </Button>
                                            </motion.div>
                                        </div>
                                    </motion.div>
                                ) : (
                                    <motion.div
                                        key="cliente"
                                        layout
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <motion.h4 className="color-primary mb-3"
                                            initial={{ opacity: 0, y: -90 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.5, ease: "easeOut", delay: 0.3 }}>
                                            Información Por Cliente
                                        </motion.h4>
                                        <div className="row">
                                            <motion.div
                                                className="col-md-6 mb-3"
                                                initial={{ opacity: 0, x: -50 }}
                                                animate={{ opacity: 1, x: 0 }}
                                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.4 }}
                                            >
                                                <FormControl sx={textFieldStyle} fullWidth>

                                                    <Autocomplete
                                                        disablePortal
                                                        options={catClientes.map((cliente) => ({ id: cliente.clienteId, label: `${cliente.nombre} ${cliente.paterno} ${cliente.materno}` }))}
                                                        onChange={(event, newValue) => setClienteContrato(newValue ? newValue.id : null)}
                                                        getOptionLabel={(option) => option.label}
                                                        value={selectedOptionCliente}
                                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                                        renderInput={(params) => <TextField {...params} label="Cliente" variant='outlined' />}
                                                    />
                                                </FormControl>

                                            </motion.div>

                                            <motion.div
                                                className="col-md-6 mb-3"
                                                initial={{ opacity: 0, x: 50 }}
                                                animate={{ opacity: 1, x: 0 }}
                                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.5 }}
                                            >
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth
                                                    label='Cantidad a Prestar'
                                                    sx={textFieldStyle}
                                                    value={cantidadPrestarFormateada}
                                                    onChange={handleCantidadPrestar}
                                                />

                                            </motion.div>

                                            <motion.div
                                                className="col-md-6 mb-3"
                                                initial={{ opacity: 0, x: -50 }}
                                                animate={{ opacity: 1, x: 0 }}
                                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.6 }}
                                            >
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth
                                                    label='% Interes'
                                                    sx={textFieldStyle}
                                                    value={porcentajeInteres}
                                                    onChange={(e) => {
                                                        const value = e.target.value;

                                                        // Permitir números del 1 al 18 con decimales
                                                        if (/^\d*\.?\d*$/.test(value)) {
                                                            const number = parseFloat(value);

                                                            if ((number >= 1 && number <= 18) || value === "") {
                                                                setPorcentajeInteres(value);
                                                            }
                                                        }
                                                    }}
                                                />

                                            </motion.div>

                                            {garantiaPrestaria === '1' &&
                                                <motion.div
                                                    className="col-md-10 mb-3"
                                                    initial={{ opacity: 0, x: -50 }}
                                                    animate={{ opacity: 1, x: 0 }}
                                                    transition={{ duration: 0.5, ease: "easeOut", delay: 0.7 }}
                                                >
                                                    <TextField
                                                        multiline
                                                        rows={2}
                                                        variant="outlined"
                                                        fullWidth
                                                        label='Garantia Prestaria'
                                                        sx={textFieldStyle}
                                                        value={garantiaPrestariaText}
                                                        onChange={(e) => setGarantiaPrestariaText(e.target.value)}
                                                    />

                                                </motion.div>

                                            }

                                            <motion.div
                                                className="col-md-12 mb-3"
                                                initial={{ opacity: 0, y: 50 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.8 }}
                                                whileHover={{
                                                    y: -4,
                                                    scale: 1.03,
                                                    filter: "brightness(1.1)",
                                                    transition: { duration: 0.25, ease: "easeOut" },
                                                }}
                                            >
                                                <Button variant="contained" fullWidth sx={styleBtn} onClick={agregarCliente} >
                                                    Agregar
                                                </Button>
                                            </motion.div>
                                            <hr />
                                            <motion.div
                                                key={page}
                                                initial={{ opacity: 0, y: 40 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.9 }}

                                            >
                                                <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
                                                    <Table >
                                                        <TableHead>
                                                            <TableRow sx={{ backgroundColor: "#0a2540" }}>
                                                                <TableCell sx={sxTableHead}>#</TableCell>
                                                                <TableCell sx={sxTableHead}>Nombre</TableCell>
                                                                <TableCell sx={sxTableHead}>Interes</TableCell>
                                                                <TableCell sx={sxTableHead}>Prestar</TableCell>
                                                                {garantiaPrestaria === '1' &&
                                                                    <TableCell sx={sxTableHead}>Garantia Prestaria</TableCell>
                                                                }
                                                                <TableCell sx={sxTableHead}>Eliminar</TableCell>
                                                            </TableRow>
                                                        </TableHead>

                                                        <TableBody>
                                                            <AnimatePresence component={null}>
                                                                {clientesAgregados
                                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((cli, index) => (
                                                                        <motion.tr
                                                                            key={index}
                                                                            initial={{ opacity: 0, x: -50 }}
                                                                            animate={{ opacity: 1, x: 0 }}
                                                                            exit={{ opacity: 0, y: -40 }}
                                                                            transition={{
                                                                                duration: 0.4,
                                                                                ease: "easeOut",
                                                                                delay: 0.1 * index
                                                                            }}
                                                                            style={{
                                                                                backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff"
                                                                            }}
                                                                        >
                                                                            <TableCell >{page * rowsPerPage + index + 1}</TableCell>
                                                                            <TableCell>{cli.nombre}</TableCell>
                                                                            <TableCell>{cli.interes}%</TableCell>
                                                                            <TableCell>{cli.cantidadPrestarFormateada}</TableCell>
                                                                            {garantiaPrestaria === '1' &&
                                                                                <TableCell>{cli.garantiaPrestaria}</TableCell>
                                                                            }
                                                                            <TableCell>
                                                                                <Tooltip text={'ELIMINAR DEL GRUPO'} position="left">
                                                                                    <DeleteOutlineIcon className="text-danger pointer" onClick={(e) => eliminarClienteGrupo(e, cli.clienteId)} />
                                                                                </Tooltip>

                                                                            </TableCell>


                                                                        </motion.tr>
                                                                    ))}
                                                            </AnimatePresence>
                                                        </TableBody>
                                                    </Table>
                                                    <TablePagination
                                                        component="div"
                                                        count={clientesAgregados.length}
                                                        page={page}
                                                        onPageChange={handleChangePage}
                                                        rowsPerPage={rowsPerPage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                        labelRowsPerPage="Registros por página"
                                                        rowsPerPageOptions={[5, 10, 25, 50]}
                                                    />
                                                </TableContainer>
                                            </motion.div>
                                        </div>

                                    </motion.div>
                                )}
                            </AnimatePresence>

                        </div>
                    </motion.div>
                </div>
            </div>
            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />
        </div>
    )

}

export default ContratoGrupal